/* eslint-disable no-unused-expressions */
import Layout from 'Layout'
import React, { useState } from 'react'
import { useEffect } from 'react';
import { useCallback } from 'react';
// import { useContext } from 'react';
// import { userContext } from 'Context/userContext';
import {  getSejarah } from 'services/apiRoutes';
import { useParams } from 'react-router-dom';
import HorizontalCard from 'components/HorizontalCard';

export default function Sejarah() {
  const {slug}=useParams()
  // const [profile,setProfile]=useState()
  // const dataContext = useContext(userContext);

  const [data,setData]= useState([]);

  const sejarahAPI = useCallback(async () => {
    const res = await getSejarah(slug);
    if (res.error) {
      return res.message;
    } else {
      const { data } = res.data;
      setData(data);
    }
  }, [slug]);

    //  const profileAPI = useCallback(async () => {
    //    const res = await getProfile(slug);
    //    if (res.error) {
    //      return res.message;
    //    } else {
    //      const { data } = res.data;
    //      setProfile(data);
    //    }
    //  }, [slug]);

 useEffect(() => {
   sejarahAPI();
  //  profileAPI();
 }, [sejarahAPI]);
 
  return (
    <Layout>
      <div className="items-center px-5 xl:pt-44 pt-28 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold xl:mb-20 mb-14 xl:text-7xl">
          Sejarah Gampong
        </h1>
        <div className="mb-20">
          <HorizontalCard
            // desc="90% Masyarakat Gampong Geulanggang teungoh adalah Petani"
            title="Kegiatan Gampong"
            img={data[0]?.url_gambar}
          />
        </div>
        {/* <div className="relative my-16 rounded2xl">
          <img
            crossOrigin="anonymous"
            src={data[0]?.url_gambar}
            alt={data[0]?.deskripsi}
            className="object-cover w-full rounded-2xl xl:h-[600px]"
          />
          <div className="absolute w-full p-5 font-bold text-white border border-white xl:w-auto xl:text-5xl xl:mx-12 bottom-1/3 rounded-2xl wrapperBlur">
            <h1>{`Sejarah ${profile?.ProfilDesa[0]?.nama}`}</h1>
          </div>
        </div> */}
        <div className="p-5 leading-6 border xl:p-10 rounded-2xl border-borderCardFeatures mb-28">
          <div dangerouslySetInnerHTML={{ __html: data[0]?.deskripsi }} />
          {/* <p className="text-justify text-articleTitle">{data[0]?.deskripsi}</p> */}
          {/* <p className="text-justify text-articleTitle">
            Pada zaman dahulu kala, nama Gampong Geulanggang Teungoh merupakan
            gampongnya areal perternakan yang sangat dikenal dikalangan
            masyarakat Bireuen. Menurut cerita tokoh-tokoh masyarakat Bireuen,
            nama gampong tersebut bermula dari pengembalaan binatang ternak yang
            sangat banyak yang dilakukan masyarakat Bireuen. Gampong tersebut
            menjadi{" "}
            <span className="font-semibold text-spanBolder">
              ”Arena (Gelanggang)”
            </span>{" "}
            tempat hewan-hewan ternak yang dilepaskan bebas saling beradu. Di
            samping itu juga ada suatu lokasi yang dahulu dikenal dengan{" "}
            <span className="font-semibold text-spanBolder">
              ”Uteuen Rambong (Hutan atau Kebun Karet)”
            </span>{" "}
            yang sering dikunjungi masyarakat Bireuen pada sore dan malam hari
            untuk menonton berbagai macam acara kesenian budaya rakyat Aceh yang
            ditampilkan dilokasi tersebut.
          </p>
       
          <p className="text-justify text-articleTitle">
            Dicetuskanlah nama{" "}
            <span className="font-semibold text-spanBolder">
              Gampong Geulanggang Teungoh
            </span>{" "}
            yang disebabkan berada ”ditengah” yang diapit oleh Gampong lain yang
            sebelah Utara berbatasan dengan Gampong Geulanggang Kulam dan
            sebelah selatan dengan Gampong Geulanggang Gampong. Sekarang Sebelah
            Timur berbatas dengan Gampong Geulanggang Baro yang merupakan
            gampong pemekaran sejak tahun 2005 yang sebelumnya wilayahnya Dusun
            Baru Gampong Geulanggang Teungoh. Gampong Geulanggang Teungoh yang
            memiliki wilayahnya seluas 248 Ha berdiri sekitar pada tahun 1920.
            Gampong Geulanggang Teungoh yang terdiri dari 4 dusun, antara lain:
            Dusun Timur, Dusun Teungoh, Dusun Barat dan Dusun Lagang.
          </p> */}
        </div>
      </div>
    </Layout>
  );
}
